/**
 * @generated SignedSource<<f731ee273cd5b6ca0d39f5edae60cd57>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpsertExperimentsSpeculativeDataInput = {
  input: ExperimentsSpeculativeDataInput;
};
export type ExperimentsSpeculativeDataInput = {
  flagName: string;
  payload: string;
  variantName: string;
};
export type ExperimentsRecordExperimentsSpeculativeDataMutation$variables = {
  input: UpsertExperimentsSpeculativeDataInput;
};
export type ExperimentsRecordExperimentsSpeculativeDataMutation$data = {
  readonly upsertExperimentsSpeculativeData: {
    readonly errors: ReadonlyArray<{
      readonly __typename: string;
      readonly message?: string;
    }> | null | undefined;
    readonly experimentsSpeculativeDataNode: {
      readonly flagName: string | null | undefined;
      readonly id: string;
      readonly payload: {
        readonly rootElement: any;
      } | null | undefined;
      readonly variantName: string | null | undefined;
    } | null | undefined;
  };
};
export type ExperimentsRecordExperimentsSpeculativeDataMutation = {
  response: ExperimentsRecordExperimentsSpeculativeDataMutation$data;
  variables: ExperimentsRecordExperimentsSpeculativeDataMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpsertExperimentsSpeculativeDataPayload",
    "kind": "LinkedField",
    "name": "upsertExperimentsSpeculativeData",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ExperimentsSpeculativeDataNode",
        "kind": "LinkedField",
        "name": "experimentsSpeculativeDataNode",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "flagName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "variantName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "JsonDocument",
            "kind": "LinkedField",
            "name": "payload",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "rootElement",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "message",
                "storageKey": null
              }
            ],
            "type": "Error",
            "abstractKey": "__isError"
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ExperimentsRecordExperimentsSpeculativeDataMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ExperimentsRecordExperimentsSpeculativeDataMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f34574bcac9fe906b6e38811b70e1536",
    "id": null,
    "metadata": {},
    "name": "ExperimentsRecordExperimentsSpeculativeDataMutation",
    "operationKind": "mutation",
    "text": "mutation ExperimentsRecordExperimentsSpeculativeDataMutation(\n  $input: UpsertExperimentsSpeculativeDataInput!\n) {\n  upsertExperimentsSpeculativeData(input: $input) {\n    experimentsSpeculativeDataNode {\n      id\n      flagName\n      variantName\n      payload {\n        rootElement\n      }\n    }\n    errors {\n      __typename\n      ... on Error {\n        __isError: __typename\n        message\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f08ee918a0adb3c0e2bd3a538f9634b1";

export default node;
